export const INIT_BOOKING_FLOW = 'BUS/INIT_BOOKING_FLOW';

export function busInitBookingFlow(initialReservationDateTime) {
  return { type: INIT_BOOKING_FLOW, initialReservationDateTime };
}
